<section id="main" class="bg-light">
     <div
          id="appExContainer"
          class="container"
     >
          <div class="row">
               <div class="col-12">
                    <h1
                         [innerHtml]="'AppEx' | translator: 'base'"
                    >An Exception Has Occurred
                    </h1>
                    <p>
                         <span [innerHtml]="'AppExHelp-1' | translator: 'base'">Please either try again or </span>

                         <a routerLink="/customerSupport" [title]="'AppExHelp-2' | translator: 'base'" tabindex="1">
                              <span [innerHtml]="'AppExHelp-2' | translator: 'base'">contact PSP Customer Service team</span>
                         </a>

                         <span [innerHtml]="'AppExHelp-3' | translator: 'base'">
                              . The PSP Customer Support Team is available by phone Monday through Thursday from 8 AM to 6 PM ET, and on Friday from 8 AM to 5 PM ET at <a
                                   name="877-642-9499"
                                   href="tel:8776429499"
                                   title="Phone number 8776429499"
                              >877-642-9499</a>.
                         </span>
                    </p>
               </div>
          </div>
     </div>
</section>